import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiClock, FiAlertTriangle } = FiIcons;

const UpcomingDeadlines = ({ records = [], learners = [], campaigns = [] }) => {
  const today = new Date();
  const in30 = new Date(); in30.setDate(today.getDate() + 30);

  const upcoming = records
    .filter(r => {
      if (!r?.dueDate || r.source === 'phishing') return false;
      const due = new Date(r.dueDate);
      return !r?.completionDate && due >= today && due <= in30;
    })
    .map(r => {
      const learner = learners.find(l => String(l?.id) === String(r?.learnerId));
      const daysLeft = Math.ceil((new Date(r.dueDate) - today) / (1000 * 60 * 60 * 24));
      return { ...r, learner, daysLeft };
    })
    .sort((a, b) => a.daysLeft - b.daysLeft)
    .slice(0, 6);

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <div className="flex items-center gap-2 mb-4">
        <SafeIcon icon={FiClock} className="text-violet-500" />
        <h3 className="text-sm font-semibold text-slate-700">Upcoming Deadlines (30 days)</h3>
        <span className="ml-auto text-xs text-slate-400 font-medium">{upcoming.length} records</span>
      </div>
      {upcoming.length === 0 ? (
        <p className="text-sm text-slate-400 text-center py-6">No upcoming deadlines in the next 30 days.</p>
      ) : (
        <div className="space-y-2.5">
          {upcoming.map(r => (
            <div key={r.id} className={`flex items-center gap-3 p-3 rounded-lg border ${r.daysLeft <= 7 ? 'bg-red-50 border-red-100' : r.daysLeft <= 14 ? 'bg-amber-50 border-amber-100' : 'bg-slate-50 border-slate-100'}`}>
              <div className={`w-10 h-10 rounded-lg flex flex-col items-center justify-center flex-shrink-0 text-center ${r.daysLeft <= 7 ? 'bg-red-100' : r.daysLeft <= 14 ? 'bg-amber-100' : 'bg-slate-100'}`}>
                <span className={`text-sm font-bold leading-none ${r.daysLeft <= 7 ? 'text-red-600' : r.daysLeft <= 14 ? 'text-amber-600' : 'text-slate-600'}`}>{r.daysLeft}</span>
                <span className="text-xs text-slate-400">days</span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-slate-800 truncate">{r.learner ? `${r.learner.firstName} ${r.learner.lastName}` : r.learnerId}</p>
                <p className="text-xs text-slate-500 truncate">{r.requirement || r.requiredTraining}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-xs font-semibold text-slate-600">{r.dueDate}</p>
                <p className="text-xs text-slate-400">{r.requirementType}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UpcomingDeadlines;